import styled from '@emotion/styled'
import {css} from "@emotion/react";
import {Button, ExpanderGroup, ExpanderTitleButton, Icon, suomifiDesignTokens as tokens} from "suomifi-ui-components";


export const inputCss = css`
  border: 1px solid ${tokens.colors.depthLight3};
  border-radius: 2px;
  box-sizing: border-box;
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.bodyText.fontSize.value}${tokens.values.typography.bodyText.fontSize.unit};
  font-weight: ${tokens.values.typography.bodyText.fontWeight};
  line-height: ${tokens.values.typography.bodyText.lineHeight.value};
  margin: ${tokens.spacing.xxs} 0;
  padding: ${tokens.spacing.s};
  max-width: 100%;
  width: 100%;
`;

export const Input = styled.input`
  ${inputCss}
`;

export const InputNumber = styled.input`
  ${inputCss}
  width: 3em;
  text-align: right;
  border: 1px solid ${tokens.colors.depthLight2};
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;

InputNumber.defaultProps = {type: 'number'};

export const InputRadio = styled.input`
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.bodyText.fontSize.value}${tokens.values.typography.bodyText.fontSize.unit};
  font-weight: ${tokens.values.typography.bodyText.fontWeight};
  line-height: ${tokens.values.typography.bodyText.lineHeight.value};
`;

InputRadio.defaultProps = {type: 'radio'};

export const TextArea = styled.textarea`
  ${inputCss}
`;

export const Select = styled.select`
  ${inputCss}
  display: block;
  background: ${tokens.colors.whiteBase};
  -moz-appearance: none;
  -webkit-appearance: none;
`;

export const InputIcon = styled(Icon)`
  top: 50%;
  position: absolute;
  right: ${tokens.spacing.m};
  margin-top: -0.5em;
  pointer-events: none;
`;

export const ButtonLink = styled.button`
  background: none;
  border: none;
  color: ${tokens.colors.brandBase};
  cursor: pointer;
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.bodyText.fontSize.value}${tokens.values.typography.bodyText.fontSize.unit};
  font-weight: ${tokens.values.typography.bodyText.fontWeight};
  line-height: ${tokens.values.typography.bodyText.lineHeight.value};
  padding: 0;
`;

export const Link = styled.a`
  background: none;
  border: none;
  color: ${tokens.colors.brandBase};
  cursor: pointer;
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.bodyText.fontSize.value}${tokens.values.typography.bodyText.fontSize.unit};
  font-weight: ${tokens.values.typography.bodyText.fontWeight};
  line-height: ${tokens.values.typography.bodyText.lineHeight.value};
  padding: 0;
`;

export const ButtonLinkLead = styled.button`
  background: none;
  border: none;
  color: ${tokens.colors.brandBase};
  cursor: pointer;
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.leadText.fontSize.value}${tokens.values.typography.leadText.fontSize.unit};
  font-weight: ${tokens.values.typography.leadText.fontWeight};
  line-height: ${tokens.values.typography.leadText.lineHeight.value};
  padding: 0;
`;

export const ButtonLinkSmall = styled.button`
  background: none;
  border: none;
  color: ${tokens.colors.brandBase};
  cursor: pointer;
  font-family: ${tokens.values.typography.bodyText.fontFamily};
  font-size: ${tokens.values.typography.bodyTextSmall.fontSize.value}${tokens.values.typography.bodyTextSmall.fontSize.unit};
  font-weight: ${tokens.values.typography.bodyTextSmall.fontWeight};
  line-height: ${tokens.values.typography.bodyTextSmall.lineHeight.value};
  padding: 0;
  &.right {
    float: right;
  }
`;

export const ButtonSecondaryDark = styled(Button)`
  color: ${tokens.colors.blackBase} !important;
  border: 1px solid ${tokens.colors.depthLight3} !important;
  & > svg {
    fill: ${tokens.colors.depthDark1};
  }
`;

export const ButtonSecondaryDarkNoBorder = styled(Button)`
  color: ${tokens.colors.blackBase} !important;
  background: none !important;
  & > svg {
    fill: ${tokens.colors.depthDark1};
  }
`;

export const ButtonIconOnly = styled(Button)`
  & > svg {
    margin: 0 !important;
  };
  @media (max-width: 800px) {
    padding: ${tokens.spacing.s};
  };
`;

export const ActionButtonPrimary = styled(Button)`
  background: ${tokens.colors.brandBase} !important;
  border: 1px solid ${tokens.colors.brandBase} !important;
  & > svg {
    fill: ${tokens.colors.whiteBase};
  }
`;

export const ActionButtonInverted = styled(Button)`
  background: ${tokens.colors.whiteBase} !important;
  border: 1px solid ${tokens.colors.brandBase} !important;
  & > svg {
    fill: ${tokens.colors.brandBase};
  }
`;

export const ActionButtonDisabled = styled(Button)`
  background: ${tokens.colors.depthLight3} !important;
  border: 1px solid ${tokens.colors.depthLight3} !important;
  & > svg {
    fill: ${tokens.colors.depthDark1};
  }
`;

export const ExpanderGroupBrandBase = styled(ExpanderGroup)`
  & > button {
    color: ${tokens.colors.brandBase} !important;
  }
`;

export const ExpanderTitleButtonBrandBase = styled(ExpanderTitleButton)`
  & > svg {
    color: ${tokens.colors.brandBase} !important;
  }
`;
